import React, { ReactNode } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const SpinnerView = (props: any = {}, children?: ReactNode) => {
  return (
    <Container fluid className="w-100 h-100">
      <Row>
        <Col>
          <Spinner animation="border" role="status" {...props}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Col>
      </Row>
    </Container>
  );
};

export { SpinnerView };
